import React, { useState } from 'react';
import HeikeFoto from '../assets/FOTO HEIKE PAULMANN MEMORIA 2020.jpg';
import ConstanzaFoto from '../assets/Foto Constanza Prats .jpg';
import MagalyFoto from '../assets/MAGALY ÁLVAREZ .jpg';
import LienekeFoto from '../assets/lieneke.jpeg';
import GinaFoto from '../assets/gina2.png';
import SutilFoto from '../assets/sutil.jpeg';
import FisherFoto from '../assets/jcft.jpeg';
import AngelFoto from '../assets/angel.jpeg';
import NadiaFoto from '../assets/nadia.jpeg';
import EquipoArequipaFoto from '../assets/eq1.jpeg';

const AboutUs = React.forwardRef(({ showTeamSection = true, showIntroGrid = true, showHeaderText = true, sectionTitle = 'Quiénes Somos', headerImage = null }, ref) => {
  // Video removido temporalmente para evitar errores CSP
  // Video removido temporalmente para evitar errores CSP
  // Video removido temporalmente para evitar errores CSP
  // Component for truncated text with "Ver más" functionality
  const TruncatedText = ({ text, maxLines = 8 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    
    return (
      <div>
        <p 
          className="text-gray-600 text-sm leading-relaxed"
          style={{
            display: '-webkit-box',
            WebkitLineClamp: isExpanded ? 'none' : maxLines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          }}
        >
          {text}
        </p>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-2 text-fhk-cyan-600 hover:text-fhk-cyan-700 text-sm font-medium transition-colors duration-200"
        >
          {isExpanded ? 'Ver menos' : 'Ver más'}
        </button>
      </div>
    );
  };

  const teamMembers = [
    {
      name: "Heike Paulmann Koepfer",
      role: "Presidenta",
      photo: HeikeFoto,
      bio: "Heike Paulmann es ingeniera comercial de la Universidad de Chile, con MBA de la Universidad Adolfo Ibáñez, destacada líder empresarial con amplia trayectoria en responsabilidad social, sostenibilidad y desarrollo corporativo. Fue Presidenta del directorio de Cencosud entre 2021-2023, y consejera electa de SOFOFA. Se caracteriza por su visión estratégica, capacidad de generación de alianzas, compromiso con la inclusión, equidad de género y liderazgo con impacto territorial, valores que aporta como Fundadora y Presidenta de la Fundación."
    },
    {
      name: "Constanza Prats M.",
      role: "Directora Ejecutiva",
      photo: ConstanzaFoto,
      bio: "Relacionador Público, Certificada como Gestora de inclusión laboral e implementadora de la Norma NCH 3262:2021., miembro de WEPs ONU Mujeres y de las mesas de gobierno regionales \"Mujer y Minería\" y \"Mujer Logística y Transporte\". Cofundadora del programa Somos Backanas, programas de sostenibilidad social, vinculación con la comunidad para jóvenes de comunas con altos índices de vulnerabilidad en Chile y Perú. Desde este rol he liderado iniciativas que buscan cerrar brechas de género, especialmente en STEM, mediante la articulación de comunidades, empresas, instituciones públicas y educativas, con foco en la implementación territorial. Amplia experiencia en generación de alianzas estratégicas (empresas, organizaciones, gobierno) que permiten financiamiento, apoyo logístico, mentorías y visibilidad institucional. Coordinación de redes de contacto que facilitan oportunidades de inserción profesional, intercambio de experiencias y apoyo mutuo entre organizaciones comprometidas con la equidad."
    },
    {
      name: "Magaly Álvarez M.",
      role: "Directora",
      photo: MagalyFoto,
      bio: "Ingeniera Comercial, Gestora de inclusión laboral, implementadora de la Norma NCH 3262:2021 certificada por AENOR, con vasta experiencia en gestión de proyectos enfocados en áreas de género diversidad e inclusión. Cofundadora del programa Somos Backanas, programas de sostenibilidad social, vinculación con la comunidad para jóvenes de comunas con altos índices de vulnerabilidad en Chile y Perú. Participación activa en mesas de género de gobierno, comités de educación, área minería, políticas de desprivatización de los cuidados área transporte y logística, comité de sostenibilidad en Cámara de integración Chileno Mexicana, directora de la revista de economía y negocios con perspectiva de género E-Negocios. Ha ocupado cargos gerenciales en empresas tecnológicas y de desarrollo de herramientas de innovación tecnológicas. Fundadora de 5 startups de telecomunicaciones y tecnología."
    },
    {
      name: "Lieneke María Schol Calle",
      role: "Directora",
      photo: LienekeFoto,
      bio: "Directora independiente en destacadas organizaciones como Scotiabank Perú, Promigas Perú, Gases del Pacífico, Gases del Norte del Perú, LHH DBM Perú, la Universidad de Ciencias Aplicadas y LHH Perú. Además, es consejera del Consejo Nacional de Educación. Ha sido directora en empresas como Alicorp, Cencosud, Cámara de Comercio de Lima, Banco Pichincha, Camposol, SAPIA, Pagos Digitales Peruanos y CARE Perú. En Camposol, también ocupó el cargo de vicepresidenta de Transformación, Innovación y Nuevos Negocios. Entre 2016 y 2018, se desempeñó como ministra de la Producción y secretaria de Gobierno Digital en la Presidencia del Consejo de ministros, liderando la transformación digital del Estado peruano. Cuenta con más de 15 años de experiencia en Microsoft Perú, donde ocupó roles como Country Manager, directora Comercial, directora de Marketing y Operaciones, y directora de Sector Público para la Región Andina. Previamente, trabajó 13 años en IBM del Perú en diversas posiciones técnicas y comerciales. Fue presidenta de AMCHAM Perú y actualmente es mentora en Endeavor. Es MBA por la Adolfo Ibáñez Management School, Ingeniera Industrial por la Universidad de Lima y directora Certificada por CENTRUM Católica."
    },
    {
      name: "Gina Ocqueteau",
      role: "Directora",
      photo: GinaFoto,
      bio: "Gina Ocqueteau es una de las ejecutivas chilenas más influyentes de su generación, con más de 25 años de trayectoria en liderazgo empresarial, gestión de riesgos y gobernanza corporativa. Su carrera ha estado marcada por la apertura de espacios en ámbitos tradicionalmente masculinos y por un compromiso constante con la innovación, la sostenibilidad y la formación de nuevas generaciones de líderes. En 2025, Gina hizo historia al convertirse en la primera mujer en presidir el directorio de SQM, una de las diez mayores compañías de Chile y actor estratégico a nivel global en la industria del litio. Este nombramiento representó un hito en la alta dirección empresarial, consolidando su liderazgo en instancias de máxima responsabilidad. Actualmente integra los directorios de Enel, Fundación País Digital, Fundación Imagen Chile, Fundación Chilena del Pacífico, UDD Ventures, Asia Chamber of Commerce, así como el Consejo Asesor de Empresas SB y el Consejo Empresarial de Alta Dirección de la Universidad de Chile. Entre 2017 y 2020 fue directora de ASECH, reforzando su compromiso con el emprendimiento y la innovación. Reconocida en cuatro ocasiones anteriores entre las 100 Mujeres Líderes (2006, 2007, 2016 y 2022), Gina es miembro del Panel de Expertos en Género, Salud Mental y Trabajo del Gobierno del Presidente Boric. Además, es columnista en Diario Financiero, conferencista y mentora en Mujeres Empresarias, impulsando el liderazgo femenino en la alta dirección."
    },
    {
      name: "Juan Sutil Servoin",
      role: "Director",
      photo: SutilFoto,
      bio: "Juan Sutil Servoin es fundador y Presidente de Empresas Sutil desde 1982, uno de los holdings agroindustriales más importantes del país que integra filiales como Coagra, Pacific Nut, Viña Sutil, Agrícola Sutil, Champiñones Abrantes, Frutícola Olmué en Chile y Perú, Banagro y National Raisin en Estados Unidos. Fue Presidente de la Confederación de la Producción y del Comercio de Chile (CPC) entre 2020 y 2022, liderando la articulación público-privada durante la pandemia y la crisis social, política e institucional vivida por el país. Consejero de la Sociedad Nacional de Agricultura desde 1992 y ex vicepresidente de la entidad, cofundó la Chilean Walnut Commission, ADIAC y ACOPAG. En 2015 impulsó la Corporación Reguemos Chile para avanzar en la Carretera Hídrica y fortalecer la matriz agroalimentaria, y ha creado instituciones de apoyo social como el Hogar de Niños San Ambrosio y el Jardín Ángel Gabriel. Reconocido en múltiples ocasiones como Empresario del Año por organizaciones como la Cámara Nacional de Comercio e ICARE, recibió en 2025 el premio Business as Noble Vocation de UNIAPAC. Está casado con María Isabel Condon Vial, tiene cuatro hijos y ocho nietos."
    },
    {
      name: "Juan Carlos Fisher",
      role: "Director",
      photo: FisherFoto,
      bio: "Empresario ligado al mercado de seguros, banca internacional, informática y recursos humanos. Administrador de empresas, relacionista público, gestor cultural y gestor comercial internacional. Con más de 30 años de experiencia en aseguradoras y asesoría internacional, actualmente preside la Cámara de Comercio Peruano Chilena, labor que compagina con la dirección de Euromundo Corredores de Seguros y sus intereses en firmas de informática, desarrollo de energías renovables y gestión cultural."
    },
    {
      name: 'Francisca Maira Gajardo',
      role: 'Desarrolladora de Contenido',
      bio: 'Licenciada en Literatura y Lingüística, y Profesora de Castellano de la Pontificia Universidad Católica de Chile; Coach Ontológico de The Newfield Network y Magíster en Edición de Textos de la Universidad Diego Portales y Pompeu Fabra. Ha trabajado como docente impartiendo clases de Lengua y Literatura en establecimientos escolares chilenos, tanto particulares, como subvencionados y municipales. Asimismo ha sido relatora de talleres de crecimiento personal y coaching. Posee experiencia en el ámbito de la evaluación docente donde se ha desempeñado como correctora de portafolios; constructora de preguntas para pruebas de conocimientos disciplinares; supervisora de planificaciones didácticas y relatora en el marco del sistema de evaluación docente chileno, principalmente capacitando a docentes de todo el país en el manejo de rúbricas asociadas a la aplicación de entrevistas; también ha realizado talleres para el fomento de comunidades reflexivas y talleres para directivos de establecimientos municipales para el manejo y uso eficiente de información derivada de los resultados de la evaluación docente.'
    }
  ];

  const presidentaDelDirectorio = teamMembers.find(
    (member) => member.name === 'Heike Paulmann Koepfer'
  );
  const directorOrder = [
    "Gina Ocqueteau",
    "Juan Sutil Servoin",
    "Magaly Álvarez M.",
    "Juan Carlos Fisher",
    "Lieneke María Schol Calle",
  ];
  const directors = directorOrder
    .map((name) => teamMembers.find((member) => member.name === name))
    .filter(Boolean);
  const directoraEjecutiva = teamMembers.find(
    (member) => member.name === 'Constanza Prats M.'
  );
  const equipoDeGestion = teamMembers.find(
    (member) => member.name === 'Francisca Maira Gajardo'
  );
  const areaTerritorioArequipa = [
    {
      name: 'Tania Chuquitarqui López Tes',
      role: 'Facilitadora',
      bio: 'Bachiller en Filosofía, con experiencia en desarrollo personal y liderazgo femenino en contextos educativos y comunitarios. Ha trabajado directamente con adolescentes y mujeres en situación de vulnerabilidad, promoviendo espacios seguros para el fortalecimiento de habilidades personales y el ejercicio del liderazgo. Su trabajo se centra en el desarrollo de competencias socioemocionales y en la promoción de la educación como herramienta de transformación social, contribuyendo al empoderamiento de niñas y jóvenes y a su rol como agentes de cambio en sus comunidades. Actualmente, participa como facilitadora en el programa Somos Backanas de la Fundación HK, fortaleciendo su formación en liderazgo y desarrollo personal.'
    },
    {
      name: "Nadia Jessica Condori Mamani",
      role: "Facilitadora programa Somos Backanas Arequipa",
      photo: NadiaFoto,
      bio: 'Nadia Jessica Condori Mamani es bachiller en Psicología por la Universidad Nacional de San Agustín, con formación especializada en desarrollo socioemocional y acompañamiento educativo. Cuenta con experiencia en contextos comunitarios, donde lidera procesos de bienestar estudiantil y apoyo integral a jóvenes en situación de vulnerabilidad. Su trabajo se enfoca en fortalecer habilidades personales y promover entornos seguros para el desarrollo de adolescentes. Cuenta con certificación de la International Youth Foundation como máster facilitadora en la pedagogía Passport to Success (PTS), orientada al desarrollo de habilidades socioemocionales y blandas. Actualmente, participa como facilitadora en el programa Somos Backanas de la Fundación HK, fortaleciendo su formación en liderazgo y desarrollo personal.'
    },
    {
      name: "Angel Grimaldos G.",
      role: "Coordinador Programa Somos Backanas Arequipa.",
      photo: AngelFoto,
      bio: "Magíster en Ciencias de la Educación con mención en Educación Superior y Master Facilitador certificado por la International Youth Foundation (IYF). Autor del Programa RUTA, un bootcamp de liderazgo socioemocional, empleabilidad y emprendimiento juvenil. Con más de 8 años de experiencia en facilitación experiencial, ha diseñado y facilitado talleres para más de 500 jóvenes y 50 docentes en temas de liderazgo, habilidades socioemocionales, autoconocimiento y desarrollo personal. Especializado en metodologías internacionales como Passport to Success (PTS) y CIMA de la IYF, combina aprendizaje vivencial, dinámicas interactivas y un enfoque práctico orientado a resultados. Cuenta con amplia experiencia en gestión académica como Coordinador Académico y Secretario Académico en el IESTP «Nueva Arequipa», donde ha liderado procesos de planificación, mejora continua e innovación pedagógica. Su pasión por la educación transformadora se resume en su frase: “Educar es sembrar esperanza en cada paso.”"
    }
  ];

  const headerParagraphs = [
    'La Fundación HK es una organización chilena que nace en el año 2025. Su nacimiento está inspirado en la figura de Helga Köpfer, una mujer chilena de ascendencia alemana, cuya vida destacó por su cálida fortaleza al hacer sentir a cada persona única y especial. Marcada por una fuerte inquietud espiritual y de conciencia social activa que se reflejaba en su compromiso con la sociedad, donde su trabajo con equipos comprometidos tuvo un gran alcance e impacto. Alegre, cariñosa y optimista, supo levantarse y sobreponerse siempre.',
    'El propósito de nuestra fundación es empoderar a niñas y jóvenes para prepararlas tanto en términos profesionales como en habilidades socioemocionales que las habiliten para poder optar a una mejor calidad de vida ampliando sus posibilidades y conocimientos.',
    'Una jóven que progresa, impacta positivamente su entorno más cercano. Buscamos formar líderes positivas, agentes de cambio que logren sobrellevar los momentos duros y exigentes de la vida con éxito, resiliencia y una sonrisa'
  ];

  const TeamCard = ({ member }) => {
    const isFeaturedPresident = member.name === 'Heike Paulmann Koepfer';

    return (
    <div className={`bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden mx-auto w-full ${isFeaturedPresident ? 'max-w-5xl md:flex' : 'max-w-[14rem]'}`}>
      <div className={`overflow-hidden bg-gray-100 shrink-0 ${isFeaturedPresident ? 'aspect-[4/3] md:aspect-auto md:w-80' : 'aspect-[3/4]'}`}>
        {member.photo ? (
          <>
            <img 
              src={member.photo} 
              alt={member.name}
              className="w-full h-full object-cover"
              style={{
                objectPosition: (member.name === "Heike Paulmann Koepfer" || member.name === "Magaly Álvarez M.") 
                  ? 'center 20%' 
                  : 'center center',
                filter: member.name === 'Constanza Prats M.' ? 'brightness(0.9) contrast(0.96) saturate(0.88)' : 'none'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="w-full h-full hidden items-center justify-center bg-fhk-cyan-50">
              <svg className="w-24 h-24 text-fhk-cyan-300" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
            </div>
          </>
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-fhk-cyan-50">
            <svg className="w-24 h-24 text-fhk-cyan-300" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
        )}
      </div>
      <div className={isFeaturedPresident ? 'p-6 md:p-8 flex-1' : 'p-4'}>
        <h4 className={isFeaturedPresident ? 'text-3xl md:text-4xl font-bold text-gray-800 mb-2' : 'text-xl font-bold text-gray-800 mb-2'}>{member.name}</h4>
        <p className={isFeaturedPresident ? 'text-fhk-cyan-600 font-semibold text-lg mb-4' : 'text-fhk-cyan-600 font-semibold mb-4'}>{member.role}</p>
        {member.bio && <TruncatedText text={member.bio} maxLines={8} />}
        {member.name === 'Heike Paulmann Koepfer' && (
          <div className="mt-6 pt-4 border-t border-fhk-orange-200">
            <p className="text-3xl md:text-5xl text-fhk-orange-500" style={{ fontFamily: 'Baskerville, Georgia, serif' }}>
              Heike Paulmann Koepfer
            </p>
            <p className="text-base md:text-lg uppercase tracking-[0.25em] text-gray-500 mt-2">
              Presidenta de la Fundacion
            </p>
          </div>
        )}
      </div>
    </div>
  );
  };

  return (
    <section ref={ref} id="quienes-somos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            {sectionTitle}
          </h2>
          <div className="w-24 h-1 bg-fhk-orange-500 mx-auto rounded-full mb-8"></div>
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-10 text-left">
              {headerImage && (
                <div className="flex justify-center md:justify-start shrink-0 w-full md:w-auto">
                  <img
                    src={headerImage}
                    alt={sectionTitle}
                    className="w-64 h-64 md:w-80 md:h-80 object-contain rounded-2xl shadow-lg bg-white p-2"
                  />
                </div>
              )}
              {showHeaderText && (
                <div className="space-y-5 text-gray-600 text-lg leading-relaxed max-w-4xl text-center md:text-left">
                  {headerParagraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Vision, Mission, Values Grid */}
        {showIntroGrid && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20">
          {/* Visión */}
          <div className="text-center p-8 rounded-2xl bg-fhk-cyan-50 hover:shadow-lg transition-all duration-300">
            <div className="w-16 h-16 bg-fhk-cyan-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Visión</h3>
            <p className="text-gray-600 leading-relaxed">
              "Ser una comunidad líder en América Latina que inspire transformación social, potenciando mujeres para construir 
              una sociedad más equitativa e inclusiva."
            </p>
          </div>

          {/* Misión */}
          <div className="text-center p-8 rounded-2xl bg-fhk-orange-50 hover:shadow-lg transition-all duration-300">
            <div className="w-16 h-16 bg-fhk-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Misión</h3>
            <p className="text-gray-600 leading-relaxed">
              " Empoderar a niñas y jóvenes a través de formación STEM, liderazgo y habilidades laborales para alcanzar una igualdad de género, oportunidades laborales y comunidades más prósperas, apoyadas por alianzas sólidas."
            </p>
          </div>

          {/* Valores */}
          <div className="text-center p-8 rounded-2xl bg-gray-50 hover:shadow-lg transition-all duration-300">
            <div className="w-16 h-16 bg-fhk-gray-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Valores</h3>
            <div className="space-y-2">
              <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium mr-2 mb-2">Inclusión</span>
              <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium mr-2 mb-2">Integridad</span>
              <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium mr-2 mb-2">Colaboración</span>
              <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium mr-2 mb-2">Excelencia</span>
              <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">Compromiso con el impacto</span>
            </div>
          </div>
        </div>
        )}

        {/* Historia / Origen - OCULTO */}
        {/* <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-3xl p-8 md:p-12 mb-20">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Nuestra Historia</h3>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              Fundación HK nace a partir de la iniciativa nuestras fundadoras Heike Paulmann y Magaly Álvarez,
              impulsada para reducir la brecha de género y abrir espacios de igualdad y oportunidad a niñas y jóvenes. 
              Nuestra fundación se construye sobre la base de la convicción de que cada joven merece acceso a educación de calidad, 
              mentorías significativas y oportunidades reales de desarrollo profesional.
            </p>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed mt-6">
              A través de programas formativos innovadores, alianzas estratégicas con empresas líderes y una comunidad 
              de apoyo mutuo, trabajamos día a día para crear un impacto duradero en las vidas de nuestras participantes 
              y en la sociedad en general.
            </p>
          </div>
        </div> */}

        {showTeamSection && (
          <>
            {/* Team Section */}
            <div className="text-center mb-12">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Presidenta del Directorio</h3>
              <p className="text-lg text-gray-600 max-w-4xl mx-auto">
                Liderazgo que inspira y guía la visión de la Fundación
              </p>
            </div>

            {/* Leadership Cards */}
            <div className="grid grid-cols-1 gap-6 mb-12 max-w-5xl mx-auto">
              {presidentaDelDirectorio && (
                <TeamCard key={presidentaDelDirectorio.name} member={presidentaDelDirectorio} />
              )}
            </div>

            <div className="border-t-2 border-fhk-orange-500 max-w-6xl mx-auto mb-12"></div>

            <div className="text-center mb-12">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Directorio de la Fundación</h3>
            </div>

            {/* Directors Cards */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16 max-w-6xl mx-auto">
              {directors.map((member) => (
                <TeamCard key={member.name} member={member} />
              ))}
            </div>

            {/* Nuestro Equipo */}
            <div className="text-center mb-10">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Nuestro Equipo Ejecutivo</h3>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Equipo que impulsa la operación de la Fundación
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16 max-w-5xl mx-auto">
              {directoraEjecutiva && (
                <TeamCard key={directoraEjecutiva.name} member={directoraEjecutiva} />
              )}
              {equipoDeGestion && (
                <TeamCard key={equipoDeGestion.name} member={equipoDeGestion} />
              )}
            </div>

            <div className="text-center mb-10">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Area Territorio Arequipa</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 max-w-6xl mx-auto">
              {areaTerritorioArequipa.map((member) => (
                <TeamCard key={member.name} member={member} />
              ))}
            </div>

            <div className="max-w-5xl mx-auto mb-16">
              <img
                src={EquipoArequipaFoto}
                alt="Equipo de Arequipa"
                className="w-full h-auto rounded-3xl shadow-xl object-cover"
              />
            </div>
          </>
        )}

        {/* Call to Action - OCULTO */}
        {/* <div className="text-center">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-8 md:p-12">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              ¿Te gustaría formar parte de nuestro equipo?
            </h3>
            <p className="text-lg text-white opacity-90 mb-6 max-w-2xl mx-auto">
              Estamos siempre buscando personas apasionadas por la educación y el empoderamiento de jóvenes.
            </p>
            <button className="bg-white text-purple-600 px-8 py-3 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg">
              Únete como Voluntaria/o
            </button>
          </div>
        </div> */}
      </div>
    </section>
  );
});

AboutUs.displayName = 'AboutUs';

export default AboutUs;
